module.exports = __webpack_public_path__ + "static/media/c12_2.29caadeb.png";